import {reqWithToken} from './requestHelper';

export async function getWaitingForm(){
    return (await reqWithToken('api/pebooking/review')).data;
}

export async function getCurrentRole(){
    return (await reqWithToken('api/pebooking/review/role')).data;
}